import BaseComponent from "../../baseComponent.js";
import styles from "./styles.scss";
import IdentityAccessService from "../../../core/services/identityAccessService.js";
import DashboardService from "../../../core/services/dashboardService.js";
import PreLoader from "../../common/preloader.jsx";

export class Share extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: "",
      users: [{email: ""}]
    }
  }

  componentDidMount() {
    this.$modal = $("#share-dashboard-modal");
    this.$modal.modal();
  }

  show() {
    this.$modal.modal("open");
  }

  hide() {
    this.$modal.modal("close");
  }

  removeUser(index) {
    this.state.users.splice(index, 1);
    this.setState(this.state);
  }

  share() {
    const users = this.state.users.filter(u => u.email.trim().length > 0);
    if (users.length === 0) {
      this.setState({error: true});
    } else {
      this.showLoader();
      this.findUsersId(users.map(u => u.email))
        .then(userIds => {
          if (userIds.length > 0) {
            DashboardService.shareDashboard(userIds);
          }
          this.setState({users: [{email: ""}]});
          this.hideLoader();
          this.hide();
        })
    }
  }

  showLoader() {
    this.refs.clear.style.display = "flex";
    this.refs.loader.show();
  }

  hideLoader() {
    this.refs.clear.style.display = "none";
    this.refs.loader.hide();
  }

  /**
   * Finds users persistenceId.
   * @param emails  array of users email address
   * @returns {Promise.<TResult>} array of users persistenceId
   */
  findUsersId(emails) {
    const promises = [];
    emails.forEach(email => {
      const p = IdentityAccessService.findUserByUserId(email)
        .then(user => {
          return user ? user.persistenceId : null;
        });
      promises.push(p);
    });
    return Promise.all(promises)
      .then(result => {
        return result.filter(r => r !== null);
      });
  }

  handleAdd() {
    const stateCopy = this.copyState();
    stateCopy.users.push({email: ""});
    this.setState(stateCopy);
  }

  handelRemove(index) {
    const stateCopy = this.copyState();
    stateCopy.users.splice(index, 1);
    this.setState(stateCopy);
  }

  handelChange(email, index) {
    const stateCopy = this.copyState();
    stateCopy.users[index].email = email;
    stateCopy.error = false;
    this.setState(stateCopy);
  }

  render() {
    return (
      <div className={["modal", styles.modalContainer].join(" ")} id="share-dashboard-modal">
        <div className="modal-content">
          <h4 className={styles.title}>Share this dashboard</h4>
          <ul className="collection">
            {
              this.state.users.map((u, i) => <User email={u.email} index={i}
                                                   error={this.state.error}
                                                   onAdd={this.handleAdd}
                                                   onRemove={this.handelRemove}
                                                   onChange={this.handelChange}
                                                   isLastItem={this.state.users.length - 1 === i} key={i}/>)
            }
          </ul>
        </div>
        <div className="modal-footer">
          <a className="waves-effect waves-light btn-flat" onClick={this.share}>Share</a>
          <a className="waves-effect btn-flat" onClick={this.hide}>Cancel</a>
        </div>
        <div className={styles.clear} ref="clear">
          <PreLoader ref="loader"/>
        </div>

      </div>
    )
  }
}


class User extends BaseComponent {
  remove() {
    this.props.onRemoveBtnClicked(this.props.index);
  }

  render() {
    const errorStyle = this.props.index === 0 && this.props.error ? styles.error : "";
    let button;

    if (this.props.isLastItem) {
      button = <i className="material-icons" onClick={e => this.props.onAdd()}>add_circle_outline</i>;
    } else {
      button =
        <i className="material-icons field-remove-btn" onClick={e => this.props.onRemove(this.props.index)}>remove_circle_outline</i>;
    }

    return (
      <li className={["collection-item listItem", styles.listItem].join(" ")}>
        <div className={errorStyle} style={{marginRight: "30px"}}>
          <input type="text" placeholder="Enter email address" value={this.props.email}
                 onChange={e => this.props.onChange(e.target.value, this.props.index)}/>
        </div>
        <div className="action-btn">
          {button}
        </div>
      </li>
    )
  }
}





// WEBPACK FOOTER //
// ./src/components/dashboard/share/share.jsx